import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { zoomToLevel } from "../../store/timeline";
import IconButtonComponent from "../UI/buttons/IconButton";
import { ReactComponent as ZoomInIcon } from "../../assets/icons/zoom-in-small.svg";
import { ReactComponent as ZoomOutIcon } from "../../assets/icons/zoom-out-small.svg";
import { useEffect } from "react";
import useDataSelector from "../../hooks/useDataSelector";
import labels from "../../utils/labels";
import useZoom from "../../hooks/useZoom";

const ZoomComponent = () => {
  const dispatch = useAppDispatch();

  const { timelineRange, defaultPixelPerMinute } = useAppSelector(
    (state) => state.timelineSlice,
  );

  const { selectedGanttChartTab } = useAppSelector(
    (state) => state.ganttChartSlice,
  );

  const { dataToUse } = useDataSelector();
  const { canZoomIn, isZoomOutDisabled, handleZoomIn, handleZoomOut } =
    useZoom();

  useEffect(() => {
    if (defaultPixelPerMinute && dataToUse)
      dispatch(zoomToLevel(selectedGanttChartTab !== "Custom"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultPixelPerMinute]);

  if (!timelineRange) return null;

  return (
    <div className="flex">
      <IconButtonComponent
        ariaLabel={labels.zoomIn}
        disable={!canZoomIn}
        id="zoom-in"
        icon={<ZoomInIcon width={20} height={20} />}
        onClick={handleZoomIn}
        activeColor="var(--col-text-primary)"
      />
      <IconButtonComponent
        ariaLabel={labels.zoomOut}
        disable={isZoomOutDisabled}
        id="zoom-out"
        icon={<ZoomOutIcon width={20} height={20} />}
        onClick={handleZoomOut}
        activeColor="var(--col-text-primary)"
      />
    </div>
  );
};

export default ZoomComponent;
